import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/shared/components/ui/card";
import t from "@/lang/lang";
import { PersistenceStateUsingContext } from "@/shared/lib/persistence-state/persistence-state-info";
import { CertificateListTable } from "@/routes/base-data/processes/qpm/certificates/_components/certificate-list-table";

export function CertificatesRoutePage() {
  return (
    <Card>
      <CardHeader>
        <div className="flex items-center justify-between gap-2">
          <CardTitle>{t("Zertifikate")}</CardTitle>
          <PersistenceStateUsingContext />
        </div>
        <CardDescription>
          {t("Hier können Sie Zertifikate anlegen und bearbeiten.")}
        </CardDescription>
      </CardHeader>
      <CardContent>
        <CertificateListTable />
      </CardContent>
    </Card>
  );
}
